export default __webpack_public_path__ + "static/media/pattern.1be0b7eb.png";